import React from "react";
import { styled } from "styled-components";

const Line = () => {
  return <UnderLine />;
};

const UnderLine = styled.div`
  border: 0.5px solid var(--white5-color);
`;

export default Line;
